import React, { useState, useEffect } from 'react';
import { ChevronLeft, Search, Check } from 'lucide-react';
import { tradingAPI } from '../../services/api';
import { TRADING_COLORS as C } from './constants';
import CoinIcon from './CoinIcon';

const SymbolPicker = ({ open, onClose, onSelect, current }) => {
  const [search, setSearch] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open) {
      tradingAPI.getSymbols(100).then(r => {
        setList(r.data?.symbols || []);
        setLoading(false);
      });
    }
  }, [open]);

  if (!open) return null;

  const filtered = list.filter(s =>
    s.symbol?.toLowerCase().includes(search.toLowerCase()) ||
    s.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: C.bg, zIndex: 1000 }}>
      <div style={{ padding: '16px', paddingTop: 'max(16px, env(safe-area-inset-top))', borderBottom: `1px solid ${C.border}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
          <button onClick={onClose} style={{ background: 'none', border: 'none', padding: 0 }}>
            <ChevronLeft size={24} color={C.text} />
          </button>
          <span style={{ color: C.text, fontSize: 18, fontWeight: 600 }}>Выбор пары</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: C.bgElevated, borderRadius: 8, padding: '12px 16px' }}>
          <Search size={18} color={C.textTertiary} />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Поиск" style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: C.text, fontSize: 15 }} />
        </div>
      </div>
      <div style={{ height: 'calc(100% - 130px)', overflow: 'auto' }}>
        {loading ? <div style={{ padding: 40, textAlign: 'center', color: C.textSecondary }}>Загрузка...</div> : 
          filtered.slice(0, 50).map((item, i) => (
            <button key={i} onClick={() => { onSelect(item.symbol); onClose(); }} style={{
              width: '100%', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 14,
              background: item.symbol === current ? C.bgElevated : 'transparent', border: 'none', borderBottom: `1px solid ${C.border}`,
            }}>
              <CoinIcon symbol={item.symbol} size={36} />
              <div style={{ flex: 1, textAlign: 'left' }}>
                <div style={{ color: C.text, fontWeight: 600, fontSize: 15 }}>{item.symbol.replace('USDT', '/USDT')}</div>
                <div style={{ color: C.textTertiary, fontSize: 12, marginTop: 2 }}>{item.name || 'Perpetual'}</div>
              </div>
              {item.symbol === current && <Check size={20} color={C.yellow} />}
            </button>
          ))
        }
      </div>
    </div>
  );
};

export default SymbolPicker;
